import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Garden gate tile matching fence-wood: same X-axis run and ~1.0 m height,
// with slightly taller posts and a hinged-look gate leaf between them.
const PLANK = "#c8975a";
const POST = "#6b4a2a";

const PICKET_X = [-0.3, -0.1, 0.1, 0.3];

export const gardenGate = defineModel({
  id: "garden-gate",
  batchId: "modern",
  name: "Garden gate",
  tags: ["modern", "outdoor", "garden", "gate", "fence", "wood"],
  summary: "A wooden garden gate tile matching the picket fence.",
  description:
    "The gate tile for fence-wood: two slightly taller bark posts framing a " +
    "hinged-look gate leaf — two rails, four pickets and a diagonal brace — " +
    "~1.0 m high, running along X so it drops into a fence run.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    const parts: Part[] = [
      // Taller gate posts at the tile edges.
      { geometry: new THREE.BoxGeometry(0.1, 1.15, 0.1), color: POST, position: [-0.45, 0.575, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 1.15, 0.1), color: POST, position: [0.45, 0.575, 0] },
      // Gate-leaf rails.
      { geometry: new THREE.BoxGeometry(0.76, 0.06, 0.04), color: PLANK, position: [0, 0.3, 0.03] },
      { geometry: new THREE.BoxGeometry(0.76, 0.06, 0.04), color: PLANK, position: [0, 0.72, 0.03] },
      // Diagonal brace between the rails (hinge side low, latch side high).
      {
        geometry: new THREE.BoxGeometry(0.78, 0.06, 0.035),
        color: PLANK,
        position: [0, 0.51, 0.0325],
        rotation: [0, 0, 0.58],
      },
    ];
    for (const x of PICKET_X) {
      parts.push({
        geometry: new THREE.BoxGeometry(0.1, 0.85, 0.03),
        color: PLANK,
        position: [x, 0.475, 0.065],
      });
    }
    return parts;
  },
  animations: [],
});
